<script>
  import {tick, onMount, createEventDispatcher} from 'svelte'

  import Section1 from './intro/IntroSection1.svelte'
  import Section2 from './intro/IntroSection2.svelte'
  import Section3 from './intro/IntroSection3.svelte'
  import Section4 from './intro/IntroSection4.svelte'
  import Section5 from './intro/IntroSection5.svelte'
  import Section6 from './intro/IntroSection6.svelte'

  const dispatch = createEventDispatcher()

  onMount(async () => {
    await tick()
    dispatch('mounted', {path: 'intro'})
  })

</script>

<Section1 />
<Section2 />
<Section3 />
<Section4 />
<Section5 />
<Section6 on:path />
